export default function (initialDataInteractor) {
  initialDataInteractor.initialDataIsLoaded = false;
}